import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalLector = ({
  show,
  onHide,
  onSave,
  lector,
  comedores = [],
}) => {
  const [nombre, setNombre] = useState("");
  const [activo, setActivo] = useState(true);
  const [idComedor, setIdComedor] = useState("");
  const [error, setError] = useState("");

  // Obtener proyecto de la sesión
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
  
  // Los comedores ya vienen filtrados por proyecto desde el componente padre

  useEffect(() => {
    if (lector) {
      setNombre(lector.nombre || "");
      setActivo(lector.activo !== undefined ? lector.activo : true);
      setIdComedor(lector.id_comedor || "");
    } else {
      setNombre("");
      setActivo(true);
      setIdComedor("");
    }
    setError("");
  }, [lector, show]);

  const handleSave = () => {
    if (!nombre.trim() || !idComedor) {
      setError("Todos los campos son obligatorios");
      return;
    }

    if (!selectedProject || !selectedProject.id) {
      setError("No se ha seleccionado un proyecto en la sesión");
      return;
    }

    const lectorData = {
      nombre: nombre.trim(),
      activo: activo,
      id_proyecto: selectedProject.id,
      id_comedor: parseInt(idComedor),
    };

    onSave(lectorData);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {lector ? "Editar Lector" : "Nuevo Lector"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Proyecto</Form.Label>
            <Form.Control
              type="text"
              value={selectedProject?.nombre || 'No hay proyecto seleccionado'}
              readOnly
              className="bg-light"
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Nombre del Lector *</Form.Label>
            <Form.Control
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ingrese el nombre del lector"
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Comedor *</Form.Label>
            <Form.Select
              value={idComedor}
              onChange={(e) => setIdComedor(e.target.value)}
              required
            >
              <option value="">Seleccione un comedor...</option>
              {comedores.map((comedor) => (
                <option key={comedor.id} value={comedor.id}>
                  {comedor.nombre}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="activo-checkbox"
              label="Activo"
              checked={activo}
              onChange={(e) => setActivo(e.target.checked)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {lector ? "Actualizar" : "Crear"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalLector;
